import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { StyledNext } from './index.style';

const NextButton = ({ title, onFinish, isDone }) => {
  const { t } = useTranslation();
  const handleFinishGuide = () => isDone && onFinish();

  return (
    <StyledNext onClick={handleFinishGuide}>
      <div className="button-next">
        <Typography className="title-next">{t(title)}</Typography>
      </div>
    </StyledNext>
  );
};

export default NextButton;
